import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ApplicationSummaryFromApi } from '../interfaces/applications-summary.interface';
import { PaginatedResponse } from '@app/core/models/paginated-response.model';
import { GetApplicationsSummariesParams } from '../interfaces/get-application-summaries-params.interface';
import { objectToSnake } from 'ts-case-convert';
import { getHttpParams } from '@shared/utils';
import { RESOURCE_FILTER_INITIAL_VALUES } from '../constants/resource.constants';

@Injectable({ providedIn: 'root' })
export class MultipleApplicationsHttpService {
  private readonly _http = inject(HttpClient);

  public getApplications(
    courtId: number,
    filters: GetApplicationsSummariesParams = RESOURCE_FILTER_INITIAL_VALUES,
  ): Observable<PaginatedResponse<ApplicationSummaryFromApi>> {
    const formattedFilters = objectToSnake(filters);

    const params = getHttpParams({ ...formattedFilters });

    return this._http.get<PaginatedResponse<ApplicationSummaryFromApi>>(
      `${environment.api}/courts/${courtId}/applications/`,
      { params },
    );
  }
}
